import { IScope } from "angular";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../../shared/components/views/machines/detail/tabs";
import { MachineSycuan } from "../models/machine";
import { MachineConfigurationSycuan } from "../models/machineConfiguration";
import { IReportGroup } from "../../../reporting/interfaces/IReportGroup";
import { vsComponentName as machinePartsComponentName } from "../../../parts.machines/components/machineParts";
import {
  ServerUtility,
  vsName as serverUtilityName,
} from "../../../records/server/serverUtility";
import { MachineDetailConfigurationViewArgs } from "../../shared/components/views/machines/detail/views/configurations/controller";

export function machineDetailTabComponentConfigure(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider
    .addElement({
      displayName: "Configurations",
      id: "configurations",
      uiSrefFragment: "configurations",
      requiredPermission: "machineView",
      children: [],
      stateDefinition: {
        url: "/configurations",
        template: require("!html-loader!./configurations.html").default,
        controller: [
          "$scope",
          "machine",
          "reportGroup",
          (
            $scope: IScope,
            machine: MachineSycuan,
            reportGroup: IReportGroup
          ) => {
            const s = <any>$scope;
            s.machine = machine;
            s.reportGroup = reportGroup;
            s.editSref = "^.edit";
            s.accordionHeading = (args: MachineDetailConfigurationViewArgs) => {
              const machineConfiguration = <MachineConfigurationSycuan>(
                args.machineConfiguration
              );
              const { changeIsPending, dateString, currentConfiguration } =
                args;

              const conversionTypeName =
                machineConfiguration.MachineConversionType?.Name ?? "";
              const changeTypeSuffix = conversionTypeName
                ? ` (${conversionTypeName})`
                : "";
              machineConfiguration.MachineConversionType?.Name;

              return `${
                machineConfiguration.ChangeType
              }${changeTypeSuffix} - ${dateString}${
                currentConfiguration && !changeIsPending ? " - Current" : ""
              }${changeIsPending ? " - Pending" : ""}`;
            };
          },
        ],
      },
    })
    .addElement({
      displayName: "Parts",
      id: "parts",
      uiSrefFragment: "parts",
      requiredPermission: "machineView",
      stateDefinition: {
        url: "/parts",
        component: machinePartsComponentName,
        resolve: {
          machineParts: [
            "machine",
            serverUtilityName,
            (machine: MachineSycuan, serverUtility: ServerUtility) => {
              const machineId = machine.Id;
              return serverUtility.sendApiRequest({
                method: "GET",
                url: `/api/machines/${machineId}/parts`,
              });
            },
          ],
        },
      },
    });
}
machineDetailTabComponentConfigure.$inject = [MachineDetailTabsProviderName];
